'use client';

import { FC, useRef, useState } from 'react';

import {
  FilterButton,
  FiltersContainer,
  FiltersModal,
  OutsideFilters,
  SortByMenu,
} from './FiltersTreez.components';

interface IFiltersTreez {
  showDealsFilter?: boolean;
}

const FiltersTreez: FC<IFiltersTreez> = ({ showDealsFilter = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const filterButtonRef = useRef<HTMLButtonElement | null>(null);

  const handleClick = () => {
    setIsOpen(open => !open);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <FiltersContainer>
        <FilterButton
          isExpanded={isOpen}
          onClick={handleClick}
          ref={filterButtonRef}
        />
        <OutsideFilters />
        <SortByMenu />
      </FiltersContainer>
      <FiltersModal
        isOpen={isOpen}
        onClose={handleClose}
        showDealsFilter={showDealsFilter}
        triggerRef={filterButtonRef}
      />
    </>
  );
};

export { FiltersTreez };
